import { MEDIA_TYPE_3D_MODEL } from './model-3d.js';

export const PRODUCT_MEDIA_3D_BUTTON_CLICKED_EVENT_NAME = '3d_button_clicked';

/**
 * Shared detail shape for typed 3D model metrics (button click + viewer events).
 *
 * @param {unknown} detail
 * @returns {detail is {
 *   modelUrl: string,
 *   mediaType: string,
 *   skuStripped?: string,
 *   catalog?: string,
 * }}
 */
export function isValidProductMediaLaunch3dDetail(detail) {
	if (detail === null || typeof detail !== 'object') {
		return false;
	}

	/** @type {Record<string, unknown>} */
	const record = detail;
	const modelUrl = record.modelUrl;
	const mediaType = record.mediaType;

	return mediaType === MEDIA_TYPE_3D_MODEL
		&& typeof modelUrl === 'string'
		&& modelUrl.trim() !== '';
}

/**
 * @returns {boolean}
 */
function canTrackProductMedia3dLaunch() {
	return Boolean(globalThis.tracking?.google?.use_gtag_admind_analytics)
		&& typeof globalThis.rp_app?.track?.track_ec_general === 'function';
}

/**
 * Fires `3d_button_clicked` when the shopper selects a typed `3d_model` thumbnail.
 *
 * @param {{
 *   catalog?: string,
 *   mediaType?: string,
 *   skuStripped?: string,
 * }} [detail]
 */
export function trackProductMedia3dButtonClicked(detail = {}) {
	if (!canTrackProductMedia3dLaunch()) {
		return;
	}

	/** @type {Record<string, string>} */
	const payload = {};

	if (typeof detail.catalog === 'string' && detail.catalog !== '') {
		payload.catalog = detail.catalog;
	}

	if (typeof detail.mediaType === 'string' && detail.mediaType !== '') {
		payload.media_type = detail.mediaType;
	}

	if (typeof detail.skuStripped === 'string' && detail.skuStripped !== '') {
		payload.sku_stripped = detail.skuStripped;
	}

	try {
		globalThis.rp_app.track.track_ec_general(PRODUCT_MEDIA_3D_BUTTON_CLICKED_EVENT_NAME, payload);
	} catch (_error) {
	}
}
